var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/modal/user/create/login-create-email-subscription.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "<h3 class=\"c-modal-login__h3\" data-qa-sign-up-email-messaging>\n    ";
output += runtime.suppressValue((lineno = 1, colno = 6, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["modal-login_email-update-message",runtime.makeKeywordArgs({"state": runtime.contextOrFrameLookup(context, frame, "core")})])), env.opts.autoescape);
output += "\n</h3>\n\n<li class=\"c-form-adjacent__li\">\n    <input type=\"checkbox\"\n        id=\"login-create-email-subscription\"\n        class=\"c-form-adjacent__checkbox c-form-adjacent__checkbox--long-label\"\n        data-qa-email-subscription-checkbox name=\"createEmailSubscription\"\n\n        ";
output += "\n\n        ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "emailFeatureConfig")),"defaultEmailSignUpBoxToChecked") && !runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"userLocation")),"isEUorCA")) {
output += " checked ";
;
}
output += " />\n    <label for=\"login-create-email-subscription\" class=\"c-form-adjacent__label c-form-adjacent__label--long\" data-qa-email-subscription-message>\n        ";
output += runtime.suppressValue((lineno = 14, colno = 10, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["modal-create_subscription_signup-verbiage",runtime.makeKeywordArgs({"state": runtime.contextOrFrameLookup(context, frame, "core")})])), env.opts.autoescape);
output += "\n    </label>\n</li>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/modal/user/create/login-create-email-subscription.j2"] , dependencies)